import React, { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import moment from 'moment';
import { DateTime } from 'luxon';
//if the date is datetime, it formats to HTML SHORTDATE format (YYYY MM DD) FOR INPUTS WITH CALENDAR
export function formatDate(dateToFormat) {
    if (dateToFormat.includes("T")) {
        var d = new Date(dateToFormat),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    } else {
        return dateToFormat;
    }
}

//Formats to MM DD YYYY  for FIELDS showing on the UI
export function formatDateFields(dateToFormat) {
    if (dateToFormat.includes("T")) {
        var d = new Date(dateToFormat);
        var year = d.getFullYear();
        var month = (1 + d.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = d.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return month + '/' + day + '/' + year;
    } else {
        return dateToFormat;
    }
}

export function formatDateFieldsLocalized(dateToFormat) {
    if (dateToFormat.includes("T")) {
        var d = new Date(dateToFormat);
        d = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        var year = d.getFullYear();
        var month = (1 + d.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = d.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return month + '/' + day + '/' + year;
    } else {
        return dateToFormat;
    }
}

//The dropdown creation with javascript DOM 
export function handleDropDownClick(ev, rowIndex, moreOpts, stateSettingClosed, stateSettingOpened, items, component, redirectDropdown, row) {
    var p = ev.currentTarget.firstElementChild;
    if (p.classList.contains("closed")) {
        var td = ev.currentTarget.parentNode;
        td.style.backgroundColor = "#28A745";
        td.style.justifyContent = "center"

        let rowItem = ev.currentTarget.parentElement.parentNode.parentElement.parentNode.getElementsByClassName("rt-tr-group");
        for (let item of rowItem) {
            if (td !== item.lastElementChild.lastElementChild)
                item.lastElementChild.lastElementChild.style.backgroundColor = "transparent";
        }

        for (let i = 0; i < moreOpts.length; i++) {
            moreOpts[i] = <p className="cursor closed" >
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>;
            stateSettingClosed(moreOpts);
        }

        moreOpts[rowIndex] = <OutsideAlerter rowIndex={rowIndex} currentCell={ev.currentTarget.parentNode} options={moreOpts} funClosed={stateSettingClosed}><div><p className="cursor open">
            <FontAwesomeIcon icon="times" size="2x" color="white" />
        </p>
            <div className='dropdown-content'>
                {items.map(item => { return <a key={item}><div className="pointer" onClick={(e) => redirectDropdown(item, row)}>{item}</div></a> }
                )}
                {/* redirectDropdown(item, row) */}
            </div>
        </div></OutsideAlerter>;
        stateSettingOpened(moreOpts);
    } else {
        var td = ev.currentTarget.parentNode;
        removeDropDown(td, moreOpts, rowIndex, stateSettingClosed)
        //td.style.backgroundColor = "transparent";
        //moreOpts[rowIndex] = <p className="cursor closed" >
        //  <FontAwesomeIcon icon="bars" size="sm" color="#28A745" />
        //</p>;
        //stateSettingClosed(moreOpts);
    }
}

function removeDropDown(td, moreOpts, rowIndex, stateSettingClosed) {
    //let td = ev.currentTarget.parentNode
    td.style.backgroundColor = "transparent";
    moreOpts[rowIndex] = <p className="cursor closed" >
        <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
    </p>;
    stateSettingClosed(moreOpts);
}

function useOutsideAlerter(ref, td, moreOpts, rowIndex, stateSettingClosed) {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            removeDropDown(td, moreOpts, rowIndex, stateSettingClosed);
        }
    }

    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter(props) {
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, props.currentCell, props.options, props.rowIndex, props.funClosed);

    return <div ref={wrapperRef}>{props.children}</div>;
}

OutsideAlerter.propTypes = {
    children: PropTypes.element.isRequired
};

export function formatEditDate(date) {
    // var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit" };

    // return new Date(date).toLocaleDateString("en-US", options).toLowerCase().replace(/,/g, ' -');
    var dates = moment.utc().format(date);

    console.log(date); // 2015-09-13 03:39:27

    var stillUtc = moment.utc(dates).toDate();
    var local = moment(stillUtc).local().format('MM/DD/YYYY - HH:mm A');

    return local;
}

//Removes the first character from the errors. In this case, it's a ":"
export function formatError(element) {
    return element;
}

export function formatInTimeZoneDate(isoDateString, ianaTimeZone) {
    if (isoDateString.length > 19) {
        isoDateString = isoDateString.substring(0, 19);
    }
    var localdt = DateTime.local();
    const formatted = DateTime.fromISO(isoDateString, {
        zone: !ianaTimeZone ? localdt.zoneName : ianaTimeZone
    }).toFormat("LL'/'dd'/'y '-' t ZZZZ ");
    return formatted;
}

export function formatInTimeZoneDateTime(isoDateTimeString, IanaTimeZone) {
    var localdt = DateTime.local();
    var zoneName = !IanaTimeZone ? localdt.zoneName : IanaTimeZone;
    const formatted = DateTime.fromISO(isoDateTimeString, {
        zone: 'UTC'
    }).setZone(zoneName).toFormat("LL'/'dd'/'y '-' t ZZZZ ");
    return formatted;
}